/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const FETCH_LOCATIONS_TO_ROLE_REQUEST = 'FETCH_LOCATIONS_TO_ROLE_REQUEST';
export const FETCH_LOCATIONS_TO_ROLE_SUCCESS = 'FETCH_LOCATIONS_TO_ROLE_SUCCESS';
export const FETCH_LOCATIONS_TO_ROLE_FAILURE = 'FETCH_LOCATIONS_TO_ROLE_FAILURE';
